import { Action, createReducer, on } from '@ngrx/store';
import { IBusinessesResponse } from '../models/businesses.model';
import { fromBusinessesActions, fromSelectedBusinessActions } from '../actions';
import { ErrorResponse, IGenericError } from '../../../core/models/generic-models';

export const businessesFeatureKey = 'businesses';

export interface BusinessListState {
  businessesResponse: IBusinessesResponse[];
  businessesFailure: IGenericError<ErrorResponse>;
  selectedBusiness: IBusinessesResponse;
  loaded: boolean;
}

export const initialState: BusinessListState = {
  businessesFailure: undefined,
  businessesResponse: undefined,
  selectedBusiness: undefined,
  loaded: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromBusinessesActions.loadBusinessesSuccess, (state, action) => ({
    ...state,
    businessesResponse: action.response,
    loaded: true
  })),
  on(fromBusinessesActions.loadBusinessesFailure, (state, action) => ({
    ...state,
    businessesFailure: action.error
  })),

  //Selected business
  on(fromSelectedBusinessActions.loadSelectedBusiness, (state, action) => ({
    ...state,
    selectedBusiness: action.select
  }))
);

export const getBusinessesResponse = (state: BusinessListState) => state.businessesResponse;
export const getBusinessesFailure = (state: BusinessListState) => state.businessesFailure;
export const getBusinessListIsLoaded = (state: BusinessListState) => state.loaded;
export const getSelectedBusiness = (state: BusinessListState) => state.selectedBusiness;
export const getSelectedBusinessId = (state: BusinessListState) => state?.selectedBusiness?.id;
